import React from 'react';

export default function renderFormattedText(raw) {
    const safe = String(raw ?? '');
    const normalized = safe.replace(/\\n/g, '\n');
    const segments = normalized.split(/(\*\*[\s\S]*?\*\*)/g);
    return segments.map((seg, i) => {
        const m = seg.match(/^\*\*([\s\S]*?)\*\*$/);
        return m ? <strong key={i}>{m[1]}</strong> : seg;
    });
}
